import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { invoiceTemplateFiltersSchema } from './schemas';

export const invoiceTemplateFiltersQueryOptions = queryOptions({
  queryKey: QueryKeys.invoiceTemplates.index.filters,
  queryFn: async () => {
    const { data: filters } = await fetchJson('/invoice-templates/filters', {
      schema: apiResourceSchema(invoiceTemplateFiltersSchema),
    });

    return filters;
  },
  staleTime: 5 * 60 * 1000,
  gcTime: Infinity,
});

export const useInvoiceTemplateFilters = () => {
  return useSuspenseQuery(invoiceTemplateFiltersQueryOptions);
};
